//@flow
export default {

  // Session
  LOGIN: 'login',
  LOGIN_PENDING: 'login_pending',
  LOGGED_IN: 'logged_in',
  LOGGED_OUT: 'logged_out',
  LOGOUT: 'logout',
  REMOVE_LOGIN_ERROR: 'remove_login_error',
  LOGIN_WITH_MAGIC_LINK: 'login_with_magic_link',
  LOGIN_WITH_SOFT_LINK: 'login_with_soft_link',

  // Login
  SET_REROUTE_URL: 'set_reroute_url',
  REROUTE_READY: 'reroute_ready',
  SET_RESET_PASSWORD_DATA: 'set_reset_password_data',

  // Modal
  OPEN_MODAL: 'open_modal',
  CLOSE_MODAL: 'close_modal',

  // Quote
  GET_QUOTES: 'allow_subsequent_get_quotes',
  GET_QUOTES_SUCCESS: 'get_quotes_success',
  GET_QUOTE_SUCCESS: 'get_quote_success',
  UPDATE_QUOTE: 'update_quote',
  UPDATE_QUOTE_SUCCESS: 'allow_subsequent_update_quote_success',
  CREATE_QUOTE: 'allow_subsequent_create_quote',
  CREATE_QUOTE_SUCCESS: 'create_quote_success',
  DELETE_QUOTE: 'delete_quote',
  DELETE_QUOTE_SUCCESS: 'delete_quote_success',
  DELETE_SS_QUOTES: 'delete_ss_quotes',
  DELETE_SS_QUOTES_SUCCESS: 'delete_ss_quotes_success',
  SET_QUOTE_SHIPPING_ADDRESS_SUCCESS: 'allow_subsequent_set_quote_shipping_address_success',
  SET_URL_PROMO_CODE: 'set_url_promo_code',
  RESERVE_QUOTE_ITEMS: 'allow_subsequent_reserve_quote_items',
  SET_QUOTE_PAYMENT_INFO: 'set_quote_payment_info',
  SET_QUOTE_SHIPPING_ADDRESS: 'allow_subsequent_set_quote_shipping_address',
  UPDATE_QUOTE_PAYMENT_INFO: 'update_quote_payment_info',
  SET_PROMO_CODE_SUCCESS: 'allow_subsequent_set_promo_code_success',
  SET_MUST_RESERVE_QUOTE: 'set_must_reserve_quote',
  UPDATE_MEMBERSHIP_PRICING: 'update_membership_pricing',
  SET_MSRP_CUSTOMER_GROUP: 'set_msrp_customer_group',
  RESET_RESERVATION_FAILURE: 'reset_reservation_failure',

  // Quote Items
  ADD_QUOTE_ITEM: 'add_quote_item',
  ADD_QUOTE_ITEMS: 'add_quote_items',
  UPDATE_QUOTE_ITEM_QTY: 'update_quote_item_qty',
  DELETE_QUOTE_ITEM: 'delete_quote_item',
  ADD_QUOTE_ITEM_SUCCESS: 'allow_subsequent_add_quote_item_success',
  UPDATE_QUOTE_ITEM_QTY_SUCCESS: 'update_quote_item_qty_success',
  DELETE_QUOTE_ITEM_SUCCESS: 'delete_quote_item_success',
  RESERVE_QUOTE_SUCCESS: 'reserve_quote_success',

  // Order
  CREATE_ORDER: 'create_order',
  CREATE_ORDER_SUCCESS: 'create_order_success',
  GET_ORDERS_SUCCESS: 'get_orders_success',
  GET_ORDER_SUCCESS: 'get_order_success',
  PLACE_ORDER: 'allow_subsequent_place_order',

  // Addresses
  OPEN_SHIPPING_MODAL: 'open_shipping_modal',
  CLOSE_SHIPPING_MODAL: 'close_shipping_modal',
  ADD_ADDRESS: 'add_address',
  ADD_SHIPPING_ADDRESS_CHECKOUT: 'allow_subsequent_add_shipping_address_checkout',
  DELETE_ADDRESS: 'delete_address',
  SET_FORM_ADDRESS: 'set_form_address',
  UPDATE_ADDRESS: 'allow_subsequent_update_address',

  // Autocomplete
  CLEAR_AUTOCOMPLETE_SUGGESTIONS: 'clear_autocomplete_suggestions',
  SET_SELECTED_SUGGESTION: 'set_selected_suggestion',
  SET_AUTOCOMPLETE_SUGGESTIONS: 'set_autocomplete_suggestions',

  // Credit Cards
  GET_CREDIT_CARDS_SUCCESS: 'allow_subsequent_get_credit_cards_success',
  ADD_CREDIT_CARD: 'add_credit_card',
  ADD_CREDIT_CARD_SUCCESS: 'allow_subsequent_add_credit_card_success',
  SET_STRIPE_INSTANCE: 'set_stripe_instance',
  SET_ACCEPT_INSTANCE: 'set_accept_instance',

  // * controls for checkout billing payment method modal
  OPEN_CHECKOUT_PAYMENT_METHOD_MODAL: 'open_checkout_payment_method_modal',
  CLOSE_CHECKOUT_PAYMENT_METHOD_MODAL: 'close_checkout_payment_method_modal',

  // Categories
  GET_CATEGORIES_SUCCESS: 'get_categories_success',

  // Customer
  REMOVE_CUSTOMER_EMAIL: 'remove_customer_email',
  CREATE_CUSTOMER: 'create_customer',
  CREATE_CUSTOMER_SUCCESS: 'create_customer_success',
  SEND_PASSWORD_RESET_EMAIL: 'send_password_reset_email',
  SEND_PASSWORD_RESET_EMAIL_SUCCESS: 'send_password_reset_email_success',
  REMOVE_RESET_EMAIL_NOTICE: 'remove_reset_email_notice',
  RESET_PASSWORD_SUCCESS: 'reset_password_success',
  GET_CUSTOMER_SUCCESS: 'get_customer_success',
  UPDATE_CUSTOMER_DETAILS: 'update_customer_details',
  UPDATE_CUSTOMER_DETAILS_SUCCESS: 'allow_subsequent_update_customer_details_success',
  REMOVE_EXISTING_EMAIL_ERROR: 'remove_existing_email_error',
  SEND_MAGIC_LINK: 'send_magic_link',
  REMOVE_MAGIC_LINK_NOTICE: 'remove_magic_link_notice',
  REDEEM_GIFTCODE_SUCCESS: 'redeem_giftcode_success',
  SET_IS_RADIANCE_OPTED_IN: 'set_is_radiance_opted_in',
  SET_EMAIL_DOMAIN_VALIDATION_ERROR: 'set_email_domain_validation_error',
  SET_FRIENDBUY_DATA: 'set_friendbuy_data',


  // Account
  OPEN_EMAIL_MODAL: 'open_email_modal',
  CLOSE_EMAIL_MODAL: 'close_email_modal',
  OPEN_PASSWORD_MODAL: 'open_password_modal',
  CLOSE_PASSWORD_MODAL: 'close_password_modal',
  NOTIFICATION_MODAL: 'notification_modal',

  // Products
  GET_PRODUCT_SUCCESS: 'allow_subsequent_get_product_success',
  GET_PRODUCTS_SUCCESS: 'get_products_success',
  GET_PRODUCTS_BY_SKUS_SUCCESS: 'get_products_by_skus_success',

  // Reviews
  GET_PRODUCT_REVIEW_SUMMARIES_SUCCESS: 'get_product_review_summaries_success',

  // Stock
  GET_STOCK_SUCCESS: 'get_stock_success',

  // Filters
  CLEAR_FILTERS: 'clear_filters',
  ADD_FILTER: 'add_filters',
  REMOVE_FILTER: 'remove_filter',
  TOGGLE_FILTER: 'toggle_filter',
  TOGGLE_MOBILE_FILTERS: 'toggle_mobile_filters',

  // Cart Preview
  OPEN_CART_PREVIEW: 'open_cart_preview',
  CLOSE_CART_PREVIEW: 'close_cart_preview',

  // Create Account Modal
  OPEN_CREATE_ACCOUNT_MODAL: 'open_create_account_modal',
  CLOSE_CREATE_ACCOUNT_MODAL: 'close_create_account_modal',
  EXPAND_CREATE_ACCOUNT_MODAL: 'expand_create_account_modal',
  COLLAPSE_CREATE_ACCOUNT_MODAL: 'collapse_create_account_modal',

  // Zopim Chat
  SET_CHAT_STATUS: 'set_chat_status',
  OPEN_CHAT: 'open_chat',

  // Errors
  TIMEOUT: 'timeout',
  ERROR: 'error',
  NOT_AUTHORIZED: 'not_authorized',

  // Membership
  GET_MEMBERSHIP: 'allow_subsequent_get_membership',
  GET_MEMBERSHIP_SUCCESS: 'allow_subsequent_get_membership_success',
  UPDATE_MEMBERSHIP_SUCCESS: 'allow_subsequent_update_membership_success',
  SET_NEW_MEMBER_PLAN: 'set_new_member_plan',
  CREATE_MEMBERSHIP_SUCCESS: 'create_membership_success',
  CANCEL_MEMBERSHIP_SUCCESS: 'cancel_membership_success',
  GET_MEMBERSHIP_PLANS_SUCCESS: 'get_membership_plans_success',

  // Routing
  CHANGING_ROUTE: 'changing_route',

  // Heap
  HEAP_TRACK_SIGN_UP: 'heap_track_sign_up',
  HEAP_TRACK_CHECKOUT_STEP_ONE: 'heap_track_checkout_step_one',
  HEAP_TRACK_CHECKOUT_STEP_TWO: 'heap_track_checkout_step_two',
  HEAP_TRACK_CHECKOUT_STEP_THREE: 'heap_track_checkout_step_three',
  HEAP_TRACK_CART_GO_TO_CHECKOUT: 'heap_track_cart_go_to_checkout',
  HEAP_TRACK_CANCEL_SURVEY: 'heap_track_cancel_survey',
  HEAP_TRACK_EMAIL_CAPTURE: 'heap_track_email_capture',
  HEAP_TRACK_PAGE_PERFORMANCE: 'heap_track_page_performance',

  // Experiments
  ENABLE_EXPERIMENT: 'enable_experiment',
  DISABLE_ALL_EXPERIMENTS: 'disable_all_experiments',

  // Marketing
  GET_MKTG_DATA_SUCCESS: 'get_mktg_data_success',

  // Notifications
  ADD_NOTIFICATION: 'add_notification',
  CLEAR_NOTIFICATION: 'clear_notification',

  // HelloBar
  SET_HELLOBAR_TEXT: 'set_hellobar_text',
  RESET_HELLOBAR_TEXT: 'reset_hellobar_text',
  SET_ADDITIONAL_HELLOBAR_TEXT: 'set_additional_hellobar_text',
  SET_HELLOBAR_DATA: 'set_hellobar_data',

  // Free Gift
  FREE_GIFT_UPDATE_UX: 'free_gift_update_ux',
  FREE_GIFT_MODAL: 'free_gift_modal',

  // Checkout
  UPDATE_SHIPPING_METHOD: 'update_shipping_method',
  RESET_CHECKOUT_STEP_STATE: 'reset_checkout_step_state',
  FIRST_STEP_CHECKOUT: 'first_step_checkout',
  FIRST_STEP_CHECKOUT_SUCCESS: 'first_step_checkout_success',
  FIRST_STEP_CHECKOUT_AMAZON_SUCCESS: 'first_step_checkout_amazon_success',
  SUB2SAVE_LEARN_MORE_MODAL: 'sub2save_learn_more_modal',
  SUB2SAVE_SELECTION_MODAL: 'sub2save_selection_modal',
  SUB2SAVE_UPGRADE_BOX_MODAL: 'sub2save_upgrade_box_modal',
  CHECKOUT_UPSELL_MODAL: 'checkout_upsell_modal',
  DISABLE_AMAZON_FOR_ORDER: 'disable_amazon_for_order',

  // Modal Names
  EDIT_AMAZON_MODAL: 'edit_amazon_modal',
  DISCONNECT_FROM_AMAZON_MODAL: 'disconnect_from_amazon_modal',
  DISCONNECT_FROM_AMAZON_NEW_PAYMENT_MODAL: 'disconnect_from_amazon_new_payment_modal',
  AMAZON_CHECKOUT_ERROR_MODAL: 'amazon_checkout_error_modal',
  CHAT_INFO_MODAL: 'chat_info_modal',
  PROMO_EMAIL_CAPTURE_MODAL: 'promo_email_capture_modal',
  LOGIN_MODAL: 'login_modal',
  RESET_EMAIL_SENT_MODAL: 'reset_email_sent_modal',
  MSRP_POP_MODAL: 'msrp_pop_modal',
  ABOUT_MEMBERSHIP_MODAL: 'about_membership_modal',
  LEARN_MORE_MODAL: 'learn_more_modal',
  SUBSCRIBE_TO_SAVE_MODAL: 'subscribe_to_save_modal',
  MAGIC_LINK_SENT_MODAL: 'magic_link_sent_modal',
  MAGIC_LINK_MODAL: 'magic_link_modal',
  MEMBERSHIP_HISTORY_MODAL: 'membership_history_modal',
  CANCEL_MEMBERSHIP_MODAL: 'cancel_membership_modal',
  CANCEL_SUBSCRIPTION_MODAL: 'cancel_subscription_modal',
  PERSONALIZED_MESSAGE_MODAL: 'personalized_message_modal',
  GIFT_CARD_PURCHASE_MODAL: 'gift_card_purchase_modal',
  UPSELL_MODAL: 'upsell_modal',
  ACCOUNT_PAYMENT_METHOD_MODAL: 'account_payment_method_modal',
  RADIANCE_MODAL: 'radiance_modal',
  ACCOUNT_ADDRESS_MODAL: 'account_address_modal',
  PAYMENT_METHOD_MODAL: 'payment_method_modal',
  SEARCH_MODAL: 'search_modal',

  // Notification names
  CART_NOTIFICATION: 'cart_notification',
  PROMO_NOTIFICATION: 'promo_notification',
  STORE_CREDIT_NOTIFICATION: 'store_credit_notification',
  UPSELL_NOTIFICATION: 'upsell_notification',

  // Promotions
  SET_ACTIVE_PROMOTION: 'set_active_promotion',
  ADD_OR_UPDATE_PROMOTION: 'add_or_update_promotion',
  ACTIVATE_PROMOTION: 'activate_promotion',
  ACTIVATE_PROMOTIONS: 'activate_promotions',

  // Amazon Pay
  SET_AMAZON_LOADED: 'set_amazon_loaded',
  SET_AMAZON_BILLING_ID: 'set_billing_id',
  CHECKOUT_WITH_AMAZON_PAY_SUCCESS: 'checkout_with_amazon_pay_success',
  SET_MEMB_TO_USE_CREDIT_CARD: 'set_memb_to_use_credit_card',
  UPDATE_QUOTE_WITH_AMAZON: 'update_quote_with_amazon',
  UPDATE_QUOTE_WITH_AMAZON_SUCCESS: 'update_quote_with_amazon_success',

  // Out of stock reminders
  SET_STOCK_REMINDER: 'set_stock_reminder',
  SET_STOCK_REMINDER_SUCCESS: 'set_stock_reminder_success',
  GET_STOCK_REMINDERS: 'get_stock_reminders',
  GET_STOCK_REMINDERS_SUCCESS: 'get_stock_reminders_success',
  IS_LOADING: 'is_loading',
  LOAD_COMPLETED: 'load_completed',

  // Support
  SUPPORT_LINK: 'https://support.naturebox.com',
};
